import { Project } from '../Models/Project';
import  ActionType  from './ActionType';
import { IGetProjectPath } from '../Models/IGetProject';

export const initialProjectState: ProjectState = {
  loading: false,
  projects: [],
  currentProject: null,
  currentProjectPath: [],
};

export interface ProjectState {
  loading: boolean;
  projects: Project[];
  currentProject: Project;
  currentProjectPath: IGetProjectPath[];
}

export type projectAction =
  | { type: ActionType.FETCH_PROJECTS; data: boolean }
  // | { type: ActionType.SET_CURRENT_PROJECT; data: Project }
  | {
      type: ActionType.SET_CURRENT_PROJECT_AND_PATH;
      data: { project: Project; path: IGetProjectPath[] };
    };

export const projectReducer = (state: ProjectState, action: projectAction) => {
  switch (action.type) {
    case ActionType.FETCH_PROJECTS:
      return { ...state, data: true };
    case ActionType.SET_CURRENT_PROJECT_AND_PATH:
      return {
        ...state,
        currentProject: action.data.project,
        currentProjectPath: action.data.path,
      };

    /*     case ActionType.SET_CURRENT_PROJECT:
      return { ...state, currentProject: action.data };

    case ActionType.SET_CURRENT_PROJECT_PATH:
      return { ...state, currentProjectPath: action.data }; */

    default:
      return state;
  }
};
